import {
  accountErrorFragment,
  staffErrorFragment
} from "@saleor/fragments/errors";
import { staffMemberDetailsFragment } from "@saleor/fragments/staff";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  AccountProfileUpdate,
  AccountProfileUpdateVariables
} from "./types/AccountProfileUpdate";
import {
  ChangeAccountPassword,
  ChangeAccountPasswordVariables
} from "./types/ChangeAccountPassword";

const accountProfileUpdate = gql`
  ${staffErrorFragment}
  ${staffMemberDetailsFragment}
  mutation AccountProfileUpdate($id: ID!, $input: StaffUpdateInput!) {
    staffUpdate(id: $id, input: $input) {
      errors: staffErrors {
        ...StaffErrorFragment
      }
      user {
        ...StaffMemberDetailsFragment
      }
    }
  }
`;
export const useAccountProfileUpdate = makeMutation<
  AccountProfileUpdate,
  AccountProfileUpdateVariables
>(accountProfileUpdate);

const changeAccountPassword = gql`
  ${accountErrorFragment}
  mutation ChangeAccountPassword($newPassword: String!, $oldPassword: String!) {
    passwordChange(newPassword: $newPassword, oldPassword: $oldPassword) {
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;

export const useChangeAccountPassword = makeMutation<
  ChangeAccountPassword,
  ChangeAccountPasswordVariables
>(changeAccountPassword);
